import React, { useContext, useEffect, useRef, useState } from 'react'
import Swal from 'sweetalert2';
import moment from 'moment';

import authContext from '../context/authContext/authContext';
import { useDispatch, useSelector } from 'react-redux';
import UserDetailsModal from '../components/modals/UserDetailsModal';
import AddAd from '../components/modals/AddAd';
import EditAd from '../components/modals/EditAd';
import { deleteAdAction, getAdsAction } from '../redux/actions/adsAction';


const Ads = () => {
  const dispatch = useDispatch();
  const { getConfig } = useContext(authContext)
  const config = getConfig();
  const fetchedRef = useRef(false);

  const intialState = { reqUserId: '', showUserDetailsModal: false }
  const [state, setCompleteState] = useState(intialState)
  const setState = (newState) => setCompleteState((prevState) => ({ ...prevState, ...newState }))

  const { loading, ads } = useSelector((state) => state.ads)

  const deletePartner = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      showCancelButton: true,
      reverseButtons: true // 👈 this does the trick
    }).then((result) => {
      if (result.isConfirmed) {
        confirmDeleteAchievement(id);
      }
    });
  }

  const confirmDeleteAchievement = async (id) => {
    const data = { id }
    dispatch(deleteAdAction(data, config, getAds))
  }

  const getAds = async () => {
    dispatch(getAdsAction(config))
  }

  useEffect(() => {
    if (fetchedRef.current) {
      return;
    }

    fetchedRef.current = true;
    getAds();
  }, []);

  return (
    <div className='main-container pb-1'>
      <div className="card-box mb-30">
        <div className='table-card-header'>
          <div className='d-flex align-items-center'>
            <h2 className="h4 mb-0 py-2">Ads</h2>
            {loading ? (
              <div className='ml-3'>
                <div className="spinner-border spinner-border-sm text-primary" role="status" />
              </div>
            ) : null}
          </div>
          <div>
            <button className='btn gleamdesk-blue' onClick={() => setState({ openAddAdModal: true })} disabled={loading}>
              <i className='fa fa-plus mr-1' />
              <span>New Ad</span>
            </button>
          </div>
        </div>
        <div className="overflow-x-scroll">
          <table className="table table-hover">
            <thead>
              <tr>
                <th scope="col">Image</th>
                <th scope="col">Title</th>
                <th scope="col">Link</th>
                <th scope="col">Type</th>
                <th scope="col">Created At</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              {(ads || []).map((ad) => {
                const { _id, title, url, image, type, createdAt } = ad;
                return (
                  <tr key={_id}>
                    <td className='cursor-pointer'>
                      <img src={image} className='img-ad' alt={title || "Ad"} />
                    </td>
                    <td>{title || '-'}</td>
                    <td>
                      <a className='text-primary' target='_blank' rel="noopener noreferrer" href={url || '#'}>{url || '-'}</a>
                    </td>
                    <td>{type || 'Announcement'}</td>
                    <td>
                      <div>{moment(createdAt).format("DD/MM/YYYY")}</div>
                      <div className='text-muted fs-12'>{moment(createdAt).format("h:mm a")}</div>
                    </td>
                    <td className='actions-container'>
                      <button className='btn btn-secondary btn-sm my-1 mx-1' onClick={() => setState({ openEditAdModal: true, adId: _id })} disabled={loading}>
                        <i className='fa fa-pencil' />
                      </button>
                      <button className='btn btn-danger btn-sm my-1 mx-1' onClick={() => deletePartner(_id)} disabled={loading}>
                        <i className='fa fa-trash' />
                      </button>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </div>

      <AddAd
        isOpen={state?.openAddAdModal}
        toggle={() => setState({ openAddAdModal: false })}
        getAds={getAds}
        loading={loading}
      />

      <EditAd
        isOpen={state.openEditAdModal}
        toggle={() => setState({ openEditAdModal: false, adId: null })}
        getAds={getAds}
        ads={ads}
        adId={state.adId}
        loading={loading}
      />

      <UserDetailsModal
        isOpen={state.showUserDetailsModal}
        toggle={() => setState({ reqUserId: '', showUserDetailsModal: false })}
        reqUserId={state.reqUserId}
      />
    </div >
  )
}

export default Ads;